<div
  class="max-w-max flex items-center justify-between"
  [class.gap-4]="size === 'medium'"
  [class.gap-3]="size === 'avatar'"
  [class.gap-4]="size === 'large'"
  #rate
  (click)="itemClick()"
>
  <ng-container *ngFor="let star of stars">
    <ark-ui-star
      [star]="star"
      [size]="size"
      (itemClick)="itemClickOn($event)"
    ></ark-ui-star>
  </ng-container>
</div>
